import './components'
import './init.scss'

// @ts-ignore
import focusable from 'vue-tv-focusable'
import Vue from 'vue'
import { addPortNode } from '@/port'
import { bindEvent, loadResource, LoadResourceUrlType } from 'vtils'
import { dcb } from '@dcb/jssdk'
import { globalModel } from '@/model'
import { h } from '@vue/composition-api'
import { newRouteOnValueChange } from '@/utils'
import { Popup } from 'vant'

// @ts-ignore
window.Vue = Vue
loadResource({
  type: LoadResourceUrlType.js,
  path: 'https://app-frontend.gogpay.cn/unifyQrCode/latest.js?v=c8d169bc-61b8-4858-bde9-7fb6fd768e46',
}).then(() => {
  // eslint-disable-next-line no-undef
  // @ts-ignore
  Vue.use(unifyQrCode.init)
  // eslint-disable-next-line no-undef
  // @ts-ignore
  unifyQrCode.tool.config(
    process.env.VUE_APP_RUN_ENV === 'production'
      ? 'production'
      : process.env.VUE_APP_RUN_ENV === 'test'
      ? 'staging'
      : 'development',
  )
})

Vue.use(focusable)

Vue.prototype.$tv.init({
  KEYS: {
    KEY_LEFT: [37], // ←
    KEY_UP: [38], // ↑
    KEY_RIGHT: [39], // →
    KEY_DOWN: [40], // ↓
    KEY_ENTER: [83, 13], // 83: s键  13：enter键
  },
  focusClassName: 'tv-key-focus',
  offsetDistance: 50,
  longPressTime: 500,
  distanceToCenter: true,
})

Vue.directive('focus-parent', {
  bind: el => {
    // @ts-ignore
    el.__off_focus_parent__ = bindEvent(el)(
      // @ts-ignore
      'onFocus',
      () => {
        let e = el
        while (e.parentElement) {
          e = e.parentElement
          if (e.hasAttribute('is-parent')) {
            e.setAttribute('parent-focused', '')
            break
          }
        }
      },
      {
        passive: true,
      },
    )
    // @ts-ignore
    el.__off_blur_parent__ = bindEvent(el)(
      // @ts-ignore
      'onBlur',
      () => {
        let e = el
        while (e.parentElement) {
          e = e.parentElement
          if (e.hasAttribute('is-parent')) {
            e.removeAttribute('parent-focused')
            break
          }
        }
      },
      {
        passive: true,
      },
    )
  },
  unbind: el => {
    // @ts-ignore
    el.__off_focus_parent__?.()
    // @ts-ignore
    el.__off_blur_parent__?.()
  },
})

Vue.directive('focus-scroll', {
  bind: (el, binding) => {
    // @ts-ignore
    el.__off_focus_scroll__ = bindEvent(el)(
      // @ts-ignore
      'onFocus',
      () => {
        Vue.prototype.$tv.scrollSpeed = 300
      },
      {
        passive: true,
      },
    )
    // @ts-ignore
    el.__off_blur_scroll__ = bindEvent(el)(
      // @ts-ignore
      'onBlur',
      () => {
        Vue.prototype.$tv.scrollSpeed = 0
      },
      {
        passive: true,
      },
    )
    // @ts-ignore
    el.__off_up_scroll__ = bindEvent(el)(
      // @ts-ignore
      'up',
      () => {
        Vue.prototype.$tv.scrollUp(
          binding.value
            ? el.querySelector(binding.value)
            : binding.modifiers.firstChild
            ? el.firstElementChild
            : el,
        )
      },
      {
        passive: true,
      },
    )
    // @ts-ignore
    el.__off_down_scroll__ = bindEvent(el)(
      // @ts-ignore
      'down',
      () => {
        Vue.prototype.$tv.scrollDown(
          binding.value
            ? el.querySelector(binding.value)
            : binding.modifiers.firstChild
            ? el.firstElementChild
            : el,
        )
      },
      {
        passive: true,
      },
    )
  },
  unbind: el => {
    // @ts-ignore
    el.__off_focus_scroll__?.()
    // @ts-ignore
    el.__off_blur_scroll__?.()
    // @ts-ignore
    el.__off_up_scroll__?.()
    // @ts-ignore
    el.__off_down_scroll__?.()
  },
})

Object.assign(Vue.prototype.$tv, {
  setScrollEl(el: any, immediate = true) {
    const run = () => {
      if (el.$el) {
        el = el.$el
      }
      Vue.prototype.$tv.scrollEl = el
    }
    if (immediate) run()
    else setTimeout(run, 210)
  },
  setLimitingEl(el: any) {
    if (el.$el) {
      el = el.$el
    }
    Vue.prototype.$tv.limitingEl = el
  },
  resetLimitingEl() {
    Vue.prototype.$tv.limitingEl = document.body
  },
  goTo(el: any, index?: number) {
    if (el.$el) {
      el = el.$el
    }
    if (index == null) {
      Vue.prototype.$tv.requestFocus(el)
    } else if (index === -1) {
      if (el.lastElementChild) {
        Vue.prototype.$tv.requestFocus(el.lastElementChild)
      }
    } else {
      if (el.children[index]) {
        Vue.prototype.$tv.requestFocus(el.children[index])
      }
    }
  },
  scrollDown(el: any) {
    if (el.$el) {
      el = el.$el
    }
    el.scrollTo({
      top: el.scrollTop + el.clientHeight * (1 / 3),
      left: 0,
      behavior: 'smooth',
    })
  },
  scrollUp(el: any) {
    if (el.$el) {
      el = el.$el
    }
    el.scrollTo({
      top: el.scrollTop - el.clientHeight * (1 / 3),
      left: 0,
      behavior: 'smooth',
    })
  },
  scrollToPageTop() {
    // 延时下，避免聚焦动效失败
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }, 210)
  },
})

dcb.onInvokeMethod('requestPayment', payload => {
  if (payload.provider === 'native' && globalModel.state.isTV) {
    return new Promise<void>((resolve, reject) => {
      const destroy = addPortNode(
        h({
          data: () => ({
            visible: false,
          }),

          watch: {
            visible() {
              // @ts-ignore
              if (!this.visible) {
                setTimeout(destroy, 4000)
                // @ts-ignore
                this.$tv.resetLimitingEl()
                reject()
              }
            },
          },

          mounted() {
            // @ts-ignore
            this.visible = true

            newRouteOnValueChange({
              // @ts-ignore
              ctx: this,
              valueName: 'visible',
              // @ts-ignore
              callback: visible => (this.visible = visible),
            })

            // @ts-ignore
            this.$nextTick(() => {
              // @ts-ignore
              this.$tv.setLimitingEl(this.$el)
            })
          },

          render() {
            return h(
              Popup,
              {
                props: {
                  value: this.visible,
                },
                style: {
                  backgroundColor: 'transparent',
                },
                on: {
                  input: (visible: boolean) =>
                    // @ts-ignore
                    (this.visible = visible),
                },
              },
              [
                // https://app-frontend.gogpay.cn/unifyQrCode/docs/index.html#/wxPay-doc.vue
                h('DTv-wxPay', {
                  props: {
                    params: payload.params,
                    width: 552,
                  },
                  on: {
                    notification: (status: number) => {
                      setTimeout(
                        () =>
                          // @ts-ignore
                          (this.visible = false),
                        0,
                      )
                      // 交易成功:1001、交易失败:1002、交易超时:1003
                      if (status === 1001) resolve()
                      else reject()
                    },
                  },
                }),
              ],
            )
          },
        }),
      )
    })
  }
})

declare module 'vue/types/vue' {
  interface Vue {
    // https://slailcp.github.io/?type=vue-tv-focusable
    $tv: {
      // focusClassName: string
      // itemAttrname: string
      // findFocusType: 0 | 1
      // initDis: number
      // offsetDistance: number
      // ...

      /** 聚焦指定的元素 */
      requestFocus: (el: Element, hasAnimation?: boolean) => void
      /** 获取指定元素的 XPath */
      readXPath: (el: Element) => string
      /** 根据 XPath 获取元素 */
      getElementByPath: (XPath: string) => Element
      /** 设置滚动的元素 */
      setScrollEl: (el: any, immediate?: boolean) => void
      /** 重置滚动的元素 */
      resetScrollEl: () => void
      /** 设置可聚焦的范围 */
      setLimitingEl: (el: any) => void
      /** 重置可聚焦的范围 */
      resetLimitingEl: () => void

      /** 跳到指定元素 */
      goTo: (el: any, index?: number) => void
      /** 向下滚动 */
      scrollDown: (el: any) => void
      /** 向上滚动 */
      scrollUp: (el: any) => void
      /** 滚动到页面顶部 */
      scrollToPageTop: () => void
    }
  }
}
